import { ExtensionRegistry } from './extension-registry';

export const EXTENSIONS = new ExtensionRegistry();
